import { languageQuery } from '@gig/magic-common';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';

var MarketingConsentsCategoryName;
(function (MarketingConsentsCategoryName) {
    MarketingConsentsCategoryName["CASINO"] = "casino";
    MarketingConsentsCategoryName["SPORTS"] = "sports";
})(MarketingConsentsCategoryName || (MarketingConsentsCategoryName = {}));
var MarketingSubConsentsName;
(function (MarketingSubConsentsName) {
    MarketingSubConsentsName["EMAIL"] = "EMAIL";
    MarketingSubConsentsName["SMS"] = "SMS";
    MarketingSubConsentsName["CALL"] = "PHONE";
    MarketingSubConsentsName["POSTALMAIL"] = "POSTALMAIL";
    MarketingSubConsentsName["NOTIFICATION"] = "PUSH_NOTIFICATION";
})(MarketingSubConsentsName || (MarketingSubConsentsName = {}));
function getAllConsents() {
    return __awaiter(this, void 0, void 0, function () {
        var lang, slugPrivacy, slugTerms, _a, privacyPageRes, termsPageRes, privacyPage, termsPage, consents, mapConsent;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, languageQuery()];
                case 1:
                    lang = _b.sent();
                    slugPrivacy = 'keycloak-privacy-cookie-policy';
                    slugTerms = 'keycloak-tnc';
                    return [4 /*yield*/, Promise.all([
                            magic.methods.pages.get({ slug: slugPrivacy, lang: lang }),
                            magic.methods.pages.get({ slug: slugTerms, lang: lang }),
                        ])];
                case 2:
                    _a = _b.sent(), privacyPageRes = _a[0], termsPageRes = _a[1];
                    if (typeof privacyPageRes === 'string' ||
                        typeof termsPageRes === 'string') {
                        throw new Error('Failed to fetch pages');
                    }
                    privacyPage = privacyPageRes;
                    termsPage = termsPageRes;
                    consents = [
                        {
                            consentId: 337,
                            name: ConsentName.PRIVACY_COOKIE_POLICY,
                            version: privacyPage.version,
                            isMandatory: true,
                            consented: null,
                            consentContents: [
                                {
                                    languageAlpha2Code: lang,
                                    header: privacyPage.description,
                                    content: 'That my personal data will be processed according to the <a class="link" href="/en/?modal=%2Fen%2Ftnc%2Fprivacy-and-cookie-policy">privacy and cookie policy</a> by Gaming Group plc, as data controller.\nConveniently deploy holistic vortals whereas competitive results. Quickly administrate business customer service without maintainable solutions. Compellingly innovate.',
                                },
                            ],
                        },
                        {
                            consentId: 348,
                            name: ConsentName.TERMS,
                            version: termsPage.version,
                            isMandatory: true,
                            consented: null,
                            consentContents: [
                                {
                                    languageAlpha2Code: lang,
                                    content: 'THIS IS A SMALL SUMMARY V225',
                                    header: termsPage.description,
                                },
                            ],
                        },
                        {
                            consentId: 8755,
                            name: MarketingConsentsCategoryName.CASINO,
                            version: '1',
                            isMandatory: false,
                            consented: null,
                            consentContents: [
                                {
                                    languageAlpha2Code: lang,
                                    content: '',
                                    header: '',
                                },
                            ],
                            subConsents: [
                                {
                                    consentId: 6577,
                                    name: MarketingSubConsentsName.EMAIL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 6544,
                                    name: MarketingSubConsentsName.SMS,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 4654,
                                    name: MarketingSubConsentsName.CALL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 45645,
                                    name: MarketingSubConsentsName.POSTALMAIL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 3545,
                                    name: MarketingSubConsentsName.NOTIFICATION,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            consentId: 4533,
                            name: MarketingConsentsCategoryName.SPORTS,
                            version: '1',
                            isMandatory: false,
                            consented: null,
                            consentContents: [
                                {
                                    languageAlpha2Code: lang,
                                    content: '',
                                    header: '',
                                },
                            ],
                            subConsents: [
                                {
                                    consentId: 3245,
                                    name: MarketingSubConsentsName.EMAIL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 5424,
                                    name: MarketingSubConsentsName.SMS,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 4542,
                                    name: MarketingSubConsentsName.CALL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 4520,
                                    name: MarketingSubConsentsName.POSTALMAIL,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                                {
                                    consentId: 4523,
                                    name: MarketingSubConsentsName.NOTIFICATION,
                                    version: '1',
                                    isMandatory: false,
                                    consented: null,
                                    consentContents: [
                                        {
                                            languageAlpha2Code: lang,
                                            content: '',
                                            header: '',
                                        },
                                    ],
                                },
                            ],
                        },
                    ];
                    mapConsent = function (consent) { return (__assign(__assign({}, consent), { consented: consent.consented || false, consentContents: consent.consentContents.find(function (_a) {
                            var languageAlpha2Code = _a.languageAlpha2Code;
                            return languageAlpha2Code === lang;
                        }), subConsents: consent.subConsents
                            ? consent.subConsents.map(mapConsent)
                            : undefined })); };
                    return [2 /*return*/, consents.map(mapConsent)];
            }
        });
    });
}

export { MarketingConsentsCategoryName, MarketingSubConsentsName, getAllConsents };
